'use client';

import { useAtomValue } from 'jotai';

import { Typography } from '@gds/Typography/Typography';

import { navTrayOpenAtom } from '../../Atoms/NavTrayOpenAtom';
import type { NavItem, SubNavGroup } from '../../Entities/Nav.entity';
import { itemOnClick, TrackedLink, trackingFunction } from '../TrackedLink/TrackedLink';
import { NavMenu } from './NavMenu/NavMenu';

import styles from './NavMenuWrapper.module.css';

export const NavMenuWrapper = ({
  navItems,
  strings,
  showMenuTitle,
  origin = 'header',
}: {
  navItems: NavItem[];
  strings: Record<string, string>;
  showMenuTitle?: boolean;
  origin?: 'header' | 'footer';
}) => {
  const isNavOpen = useAtomValue(navTrayOpenAtom);
  return (
    <div
      className={`${styles.navMenuWrapper} ${isNavOpen ? styles.addTransition : ''} ${
        origin === 'footer' ? styles.footerEnabled : ''
      }`}
    >
      {showMenuTitle && (
        <Typography variant="h6" Component="div" className={styles.menuHeader}>
          {strings.explorerLabel}
        </Typography>
      )}
      <nav
        className={styles.navMenu}
        aria-label={origin === 'header' ? 'primary-navigation-mobile' : 'footer-navigation'}
      >
        <ul className={styles.navList}>
          {navItems.map((navItem, index) => {
            const { label, subNavGroups, href, redirectUrl } = navItem;

            return (
              <li
                key={index}
                className={styles.navItem}
                onClick={() =>
                  itemOnClick({
                    fn: trackingFunction,
                    obj: { label },
                  })
                }
              >
                {navItem.subNavGroups && navItem.subNavGroups.length > 0 ? (
                  <NavMenu
                    label={label}
                    subNavGroups={subNavGroups as SubNavGroup[]}
                    redirectUrl={
                      Array.isArray(redirectUrl) && redirectUrl[0] ? redirectUrl[0] : undefined
                    }
                    origin={origin}
                  />
                ) : (
                  <TrackedLink
                    className={styles.navLink}
                    href={href ?? '/'}
                    trackingObj={{ label: label, href: href }}
                    origin={origin}
                  >
                    {navItem.label}
                  </TrackedLink>
                )}
              </li>
            );
          })}
        </ul>
      </nav>
    </div>
  );
};
